import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@devhop/ui";
import brandMark from "@/assets/icon.png";

type TeamSwitcherProps = {
  teams: {
    name: string;
    logo: React.ElementType;
    plan: string;
  }[];
};

export function TeamSwitcher({ teams }: TeamSwitcherProps) {
  const activeTeam = teams[0] || {
    name: "Life Football CF",
    plan: "ລະບົບ CF",
  };

  const logoUrl =
    typeof brandMark === "string"
      ? brandMark
      : ((brandMark as { default?: string })?.default ?? "");

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" className="hover:bg-transparent">
          <div className="flex aspect-square size-8 items-center justify-center rounded-lg">
            <img src={logoUrl} alt="Logo" className="size-8" />
          </div>
          <div className="grid flex-1 text-start text-sm leading-tight">
            <span className="truncate font-semibold">{activeTeam.name}</span>
            <span className="truncate text-xs">{activeTeam.plan}</span>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
